import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const DocumentTemplatePage_DocumentTemplate_Foapu_Mutation = graphql(`
  mutation DocumentTemplatePage_DocumentTemplate_Foapu(
    $filter: IdFilterInput!
    $update: DocumentTemplatePartialInput!
    $versionData: VersionDataInput
  ) {
    findOneAndPartialUpdateDocumentTemplate(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type DocumentTemplate_Foapu_Result = ResultOf<
  typeof DocumentTemplatePage_DocumentTemplate_Foapu_Mutation
>;

export const useFoapuDocumentTemplateMutation = () =>
  useGraphQLMutation(DocumentTemplatePage_DocumentTemplate_Foapu_Mutation);
